var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page bg-white" },
    [
      _c("el-page-header", {
        staticClass: "page-header",
        attrs: { content: "版本列表" },
        on: { back: _vm.goBack },
      }),
      _c("vxe-toolbar", {
        attrs: {
          refresh: { query: _vm.refreshList },
          export: "",
          print: "",
          custom: "",
        },
      }),
      _c(
        "div",
        { staticStyle: { height: "calc(100% - 80px)" } },
        [
          _c(
            "vxe-table",
            {
              ref: "formDefinitionJsonTable",
              attrs: {
                border: "inner",
                "auto-resize": "",
                resizable: "",
                height: "auto",
                loading: _vm.loading,
                size: "small",
                "show-header-overflow": "",
                "show-overflow": "",
                "highlight-hover-row": "",
                "menu-config": {},
                "print-config": {},
                "import-config": {},
                "export-config": {},
                "sort-config": { remote: true },
                data: _vm.dataList,
                "checkbox-config": {},
              },
              on: { "sort-change": _vm.sortChangeHandle },
            },
            [
              _c("vxe-column", { attrs: { type: "seq", width: "40" } }),
              _c("vxe-column", { attrs: { type: "checkbox", width: "40px" } }),
              _c("vxe-column", {
                attrs: {
                  title: "表单定义id",
                  field: "formDefinitionId",
                  sortable: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-link",
                          {
                            attrs: { type: "primary", underline: false },
                            on: {
                              click: function ($event) {
                                return _vm.view(scope.row.id)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.formDefinitionId))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-column", {
                attrs: { title: "流程表单结构体", field: "json", sortable: "" },
              }),
              _c("vxe-column", {
                attrs: { title: "版本号", field: "version", sortable: "" },
              }),
              _c("vxe-column", {
                attrs: { title: "状态", field: "status", sortable: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status === "1"
                          ? _c(
                              "el-tag",
                              { attrs: { size: "small", type: "success" } },
                              [_vm._v("已发布")]
                            )
                          : _c(
                              "el-tag",
                              { attrs: { size: "small", type: "danger" } },
                              [_vm._v("未发布")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-column", {
                attrs: {
                  title: "是否主版本",
                  field: "isPrimary",
                  sortable: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.isPrimary === "1"
                          ? _c(
                              "el-tag",
                              { attrs: { size: "small", type: "success" } },
                              [_vm._v("主版本")]
                            )
                          : _c(
                              "el-tag",
                              { attrs: { size: "small", type: "danger" } },
                              [_vm._v("非主版本")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-column", {
                attrs: {
                  title: "操作",
                  width: "300px",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "text",
                              icon: "el-icon-view",
                              size: "small",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.view(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("预览")]
                        ),
                        scope.row.isPrimary === "0"
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "text",
                                  icon: "el-icon-edit",
                                  size: "small",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.updatePrimary(scope.row.id)
                                  },
                                },
                              },
                              [_vm._v("设置为主版本")]
                            )
                          : _vm._e(),
                        scope.row.isPrimary === "0"
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "text",
                                  icon: "el-icon-delete",
                                  size: "small",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.del(scope.row.id)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("vxe-pager", {
        attrs: {
          background: "",
          size: "small",
          "current-page": _vm.tablePage.currentPage,
          "page-size": _vm.tablePage.pageSize,
          total: _vm.tablePage.total,
          "page-sizes": [
            10,
            20,
            100,
            1000,
            { label: "全量数据", value: 1000000 },
          ],
          layouts: [
            "PrevPage",
            "JumpNumber",
            "NextPage",
            "FullJump",
            "Sizes",
            "Total",
          ],
        },
        on: { "page-change": _vm.currentChangeHandle },
      }),
      _c("FormDefinitionJsonForm", {
        ref: "formDefinitionJsonForm",
        on: { refreshDataList: _vm.refreshList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }